// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Bio-module--avatar--1gE6Z","bioContainer":"Bio-module--bioContainer--Fk_Og"};